import { TrackingInteractiveQuestionType } from '@genially/contracts';
import { InteractiveQuestionType } from '@genially/document-model';

export type NonScoreableInteractiveQuestions =
  | InteractiveQuestionType.OpenAnswer
  | InteractiveQuestionType.Survey
  | InteractiveQuestionType.ImageSurvey;

export const nonScoreableInteractiveQuestionsList = [
  InteractiveQuestionType.OpenAnswer,
  InteractiveQuestionType.Survey,
  InteractiveQuestionType.ImageSurvey,
];

export type NonScoreableTrackingInteractiveQuestions =
  | TrackingInteractiveQuestionType.OpenAnswer
  | TrackingInteractiveQuestionType.Survey
  | TrackingInteractiveQuestionType.ImageSurvey;

export const nonScoreableTrackingInteractiveQuestionsList = [
  TrackingInteractiveQuestionType.OpenAnswer,
  TrackingInteractiveQuestionType.Survey,
  TrackingInteractiveQuestionType.ImageSurvey,
];
